import { experiment_file_to_keys } from "./file_to_keys_mapping";

export const experiment_file_validator = (selected_plant, key_name, headers) => {
  let isValid = true;
  const missing_keys = [];
  const map = {};
  headers.forEach((key) => {
    map[key.toLowerCase().split("_").join(" ")] = 1;
  });
  // console.log({ key_name });
  // console.log({ valid_keys: experiment_file_to_keys?.[selected_plant]?.[key_name].required });
  // console.log({ headers });
  experiment_file_to_keys?.[selected_plant]?.[key_name].required.forEach((value) => {
    if (!map[value.toLowerCase()]) {
      isValid = false;
      missing_keys.push(value);
    }
  });
  if (!isValid) {
    return {
      isValid,
      missing_keys
    };
  }
  return {
    isValid,
    missing_keys
  };
};